import { render, staticRenderFns } from "./item_description.vue?vue&type=template&id=f7f2bb50&scoped=true&"
import script from "./item_description.vue?vue&type=script&lang=js&"
export * from "./item_description.vue?vue&type=script&lang=js&"
import style0 from "./item_description.vue?vue&type=style&index=0&id=f7f2bb50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f2bb50",
  null
  
)

export default component.exports